const overloading = {
  breakpointNames: ['sm', 'md', 'lg', 'xl', 'xxl'],
  breakpoints: [576, 768, 992, 1200, 1600]
}

const colors = {
  colorDarkBrown : '#534741',
  colorLightBrown : '#d6c4b0'
}

const variables = {
  familyBase: '"proxima-nova",sans-serif',
  familyHeader: '"balboa-condensed",serif',
  familyHeader2: '"timberline",serif',

  primaryColor: 'red',
  fontColor: colors.colorDarkBrown,
  bgColor: '#ebebeb',

  ...colors,
  ...overloading
}

export default variables;